/** @format */

import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {QuoteContext} from 'frontier-quoter';

import {GridSelect, Radio, RadioGroup, Icon} from '@sttark/design-system';

import {
    QUOTER_SQUARE_CORNER,
    QUOTER_ROUNDED_CORNER,
    QUOTER_SHAPE_CIRCLE_OVAL,
    QUOTER_SHAPE_SQUARE_RECTANGLE,
    QUOTER_SHAPE_CUSTOM,
    QUOTER_SHAPE_PREVIOUSLY_USED,
    QUOTER_SHAPE_CHAPSTICK,
    QUOTER_SHAPE_POLYGON,
    QUOTER_SHAPE_TAMPER_SEAL,
    QUOTER_SHAPE_NEW_SHAPE,
    PRODUCT_TYPE_CARTON,
    SHAPE_CARTON_AUTOLOCK,
    SHAPE_CARTON_STRAIGHT_TUCK,
    SHAPE_CARTON_CUSTOM
} from 'frontier-constants';

import shapeAutoLock from './assets/shape-autolock.svg';
import shapeStraightTuck from './assets/shape-straigttuck.svg';
import shapeCustomCarton from './assets/shape-carton-custom.svg';
import shapeSquare from './assets/shape-square.svg';
import shapeCircle from './assets/shape-circle.svg';
import shapeCustom from './assets/shape-custom.svg';
import shapePrevious from './assets/shape-previous.svg';
import shapeChapstick from './assets/shape-chapstick.svg';
import shapeTamper from './assets/shape-tamper.svg';
import shapeHexagon from './assets/shape-hexagon.svg';
import shapeCustomNew from './assets/shape-custom-new.svg';

export default function ShapeSelect({
    shapeCategory,
    onShapeCategoryChange,
    customShapeSubCategory,
    onCustomShapeSubCategoryChange,
    corners,
    onCornersChange
}) {
    const ctx = useContext(QuoteContext);
    if (
        ctx.order.product_type_id === PRODUCT_TYPE_CARTON ||
        ctx.designOrder?.design_product_type_id === PRODUCT_TYPE_CARTON
    ) {
        return (
            <>
                <h3>Select Your Shape</h3>
                <GridSelect
                    options={[
                        {
                            label: 'Auto Lock',
                            value: SHAPE_CARTON_AUTOLOCK,
                            image: shapeAutoLock
                        },
                        {
                            label: 'Straight Tuck',
                            value: SHAPE_CARTON_STRAIGHT_TUCK,
                            image: shapeStraightTuck
                        },
                        {
                            label: 'Custom Shape',
                            value: SHAPE_CARTON_CUSTOM,
                            image: shapeCustomCarton
                        }
                    ]}
                    value={shapeCategory}
                    onChange={onShapeCategoryChange}
                />
                {shapeCategory === QUOTER_SHAPE_SQUARE_RECTANGLE && (
                    <>
                        <h5>Corners</h5>
                        <RadioGroup name="corners" value={corners} onChange={onCornersChange}>
                            <Radio label="Round Corners" value={QUOTER_ROUNDED_CORNER} />
                            <Radio label="Square Corners" value={QUOTER_SQUARE_CORNER} />
                        </RadioGroup>
                    </>
                )}
            </>
        );
    }

    if (shapeCategory === QUOTER_SHAPE_CUSTOM) {
        return (
            <>
                <h3>
                    <button
                        className="d-inline-flex align-items-center"
                        onClick={() => onShapeCategoryChange(null)}>
                        <Icon large name="navigateleft" color="#000000" /> Custom Shape Category
                    </button>
                </h3>
                <GridSelect
                    options={[
                        {label: 'Lip Balm', value: QUOTER_SHAPE_CHAPSTICK, image: shapeChapstick},
                        {label: 'Polygon', value: QUOTER_SHAPE_POLYGON, image: shapeHexagon},
                        {label: 'Tamper Seal', value: QUOTER_SHAPE_TAMPER_SEAL, image: shapeTamper},
                        {
                            label: 'Create New Shape',
                            value: QUOTER_SHAPE_NEW_SHAPE,
                            image: shapeCustomNew
                        }
                    ]}
                    value={customShapeSubCategory}
                    onChange={onCustomShapeSubCategoryChange}
                />
            </>
        );
    } else {
        return (
            <>
                <h3>Select Your Shape</h3>
                <GridSelect
                    options={[
                        {
                            label: 'Square/Rectangle',
                            value: QUOTER_SHAPE_SQUARE_RECTANGLE,
                            image: shapeSquare
                        },
                        {label: 'Circle/Oval', value: QUOTER_SHAPE_CIRCLE_OVAL, image: shapeCircle},
                        {label: 'Custom', value: QUOTER_SHAPE_CUSTOM, image: shapeCustom},
                        {
                            label: 'Previously Used',
                            value: QUOTER_SHAPE_PREVIOUSLY_USED,
                            image: shapePrevious
                        }
                    ]}
                    value={shapeCategory}
                    onChange={onShapeCategoryChange}
                />
                {shapeCategory === QUOTER_SHAPE_SQUARE_RECTANGLE && (
                    <>
                        <h5>Corners</h5>
                        <RadioGroup name="corners" value={corners} onChange={onCornersChange}>
                            <Radio label="Round Corners" value={QUOTER_ROUNDED_CORNER} />
                            <Radio label="Square Corners" value={QUOTER_SQUARE_CORNER} />
                        </RadioGroup>
                    </>
                )}
            </>
        );
    }
}

ShapeSelect.propTypes = {
    corners: PropTypes.any,
    onCornersChange: PropTypes.func,
    shape: PropTypes.any,
    onShapeChange: PropTypes.func
};
